import logger from '../utils/rbata.logger';
import recaptcha from '../utils/rbata.recaptcha';
import fileHelpers from '../utils/rbata.fileFilpers';

const contactForm = {
    ZENDESK_CODE:            'zendeskCode',
    MAIN_REASON:             'mainReason',
    $form:                   undefined,
    $formWrapper:            undefined,
    $formSuccess:            undefined,
    $errorRecaptcha:         undefined,
    $errorUpload:            undefined,
    $errorForm:              undefined,
    $anotherMessage:         undefined,
    $errorFileSize:          undefined,
    $contactPage:            undefined,
    isReady:                 false,
    invalidFields:           [],
    isReCaptchaValid:        false,
    zendesk:                 {},
    activeReason:            {},
    activeSubReason:         {},
    $selectedFilesContainer: undefined,
    files:                   [],
    formUID:                 undefined,
    MAX_FILES:               4,
    FILE_SIZE_MAX:           3145728,
    ALLOWED_FILES:           ['jpg', 'pdf', 'png', 'jpeg', 'doc', 'docx'],
    UPLOAD_TEXT:             'UPLOADING...',
    isUploadDone:            false,
    filesValid:              true,
    $progress:               undefined,

    init() {
        this.$contactPage    = $('.page-contactPage');
        this.$form           = $('#contactForm');
        this.$formWrapper    = $('.contact-form');
        this.$formSuccess    = $('.contact-form--success');
        this.$anotherMessage = $('.js-contact-form--another');
        this.$errorRecaptcha = this.$form.find('.contact__error-recaptcha');
        this.$errorUpload    = this.$form.find('.contact__error-upload');
        this.$errorForm      = this.$form.find('.contact__error-form');
        this.$errorFileSize  = this.$form.find('.contact__error-file-size');
        this.formUID         = this.generateUniqueFormID();

        // Load upload settings
        this.MAX_FILES     = this.$form.data('file-nr') || this.MAX_FILES;
        this.FILE_SIZE_MAX = this.$form.data('file-size') * Math.pow(1024, 2) || this.FILE_SIZE_MAX;
        this.ALLOWED_FILES = this.$form.data('file-ext')?.replaceAll(' ', '').split(',') || this.ALLOWED_FILES;
        this.UPLOAD_TEXT   = this.$form.data('uploading-text') || this.UPLOAD_TEXT;

        // Read zendesk data
        this.zendesk      = this.$form.data('reasons');
        this.translations = this.zendesk.translations;

        // File upload
        this.$selectedFilesContainer = this.$form.find('.js-contact-form__uploaders');
        this.$progress               = this.$form.find('progress');

        this.bindEvents();
        this.renderReasons();

        if (recaptcha.isReady()) {
            recaptcha.init(this.reCaptchaCallback, recaptcha.TYPE_INVISIBLE, this.$contactPage);
        }
    },

    /**
     * This method will generate form unique identifier which will be used to bind to uploaded files
     * to the data from the form
     */
    attachUniqueId() {
        const uid = document.createElement('input');
        uid.setAttribute('id', 'formUid');
        uid.setAttribute('name', 'fileContextCode');
        uid.setAttribute('value', this.formUID);
        uid.setAttribute('hidden', 'hidden');
        this.$form.append(uid);
    },

    generateUniqueFormID() {
        return `${(Math.random() * 10000).toFixed(0)}-${Date.now()}`
    },

    bindEvents() {
        this.$form.on('submit', contactForm.handleFormSubmit);
        this.$form.on('change keyup', contactForm.handleFormChange);
        this.$form.find('.js-contact-form__button').on('click', contactForm.handleFileSelect);
        this.$form.on('click', '.contact-form__remove-icon', contactForm.removeFile)
        this.$anotherMessage.on('click', contactForm.sendAnotherMessage);
    },

    sendAnotherMessage() {
        contactForm.isUploadDone     = false;
        contactForm.isReady          = false;
        contactForm.isReCaptchaValid = false;
        contactForm.files            = [];
        contactForm.activeReason     = {};
        contactForm.activeSubReason  = {};
        contactForm.invalidFields    = [];
        contactForm.formUID          = contactForm.generateUniqueFormID();

        if (grecaptcha) {
            grecaptcha.reset();
        }

        contactForm.$form.trigger("reset");
        contactForm.$form.find('button[type=submit]').attr('disabled', 'disabled');
        contactForm.$form.find('#formUid').remove();
        contactForm.resetOptions();
        contactForm.$formSuccess.addClass('d-none');
        contactForm.$errorForm.addClass('d-none');
        contactForm.renderAddedFiles();
        contactForm.checkButtonVisuals();
        contactForm.$formWrapper.show();

    },

    resetOptions() {
        contactForm.$firstOption.val('default').selectpicker("refresh");
        contactForm.$subOption.val('default').selectpicker("refresh")
        contactForm.cleanupFields();
    },

    // FORM EVENTS HANDLERS

    handleFormSubmit(event) {
        event.preventDefault();

        logger.log(`Is form ready: ${contactForm.isReady}`);

        // Once valid, not reason to call again
        if (!contactForm.isReCaptchaValid) {
            if (!recaptcha.getResult()) {
                recaptcha.execute();
            }
        }

        if (!contactForm.isUploadDone && contactForm.isReCaptchaValid && contactForm.filesValid) {
            // Upload files if captcha valid
            if (contactForm.files.length > 0) {
                logger.log(`There are files ->  Number: ${contactForm.files.length} -> Uploading`);
                contactForm.uploadFiles();
            } else {
                logger.log(`There are no files to be uploaded`);
            }
        } else {
            logger.log(`File size or recaptcha must be wrong.`);
        }

        if (contactForm.isReady) {
            logger.log(`Form can be submitted.`);
            contactForm.$form.find('button[type=submit]').attr('disabled', 'disabled');
            contactForm.submitFormData();
        } else {
            logger.log(`Form incomplete -> Submit blocked.`);
            logger.log(`Recaptcha valid status: ${contactForm.isReCaptchaValid}`);
            logger.log(`Form fields invalid number: ${contactForm.invalidFields.length}`);
            if (contactForm.files.length > 0) {
                logger.log(`There ${contactForm.files.length} to upload. Upload DONE: ${contactForm.isUploadDone}`);
            } else {
                logger.log(`No files selected to upload. OK`);
            }
        }
    },

    handleFormChange() {
        contactForm.checkFormFieldsValidity();
    },

    checkFormFieldsValidity() {
        this.invalidFields = [];

        this.$form.find('input:not(:hidden), select, textarea')
            .map(element => {
                const $this = $(element);
                if ($this.attr('required')) {
                    if (!$this.val().length) {
                        contactForm.invalidFields.push($this);
                    }
                }
            });

        this.invalidFields.length
                ? this.$form.find('button[type=submit]').attr('disabled', 'disabled')
                : this.$form.find('button[type=submit]').removeAttr('disabled');

        this.$errorForm.addClass('d-none');
    },

    recalculateFormState() {
        contactForm.isReady =
                contactForm.isReCaptchaValid && contactForm.invalidFields.length === 0 && (!contactForm.files.length || contactForm.isUploadDone);
    },

    submitForm() {
        this.recalculateFormState();
        contactForm.$form.trigger('submit');
    },

    // FORM RECAPTCHA
    reCaptchaCallback(token) {
        logger.log(`RECAPTCHA callback -> TOKEN RECEIVED -> VALIDATION...`);
        const result = recaptcha.verifyResult(token);
        result.then((response) => {
            if (response.success) {
                contactForm.isReCaptchaValid = true;
                logger.log(`RECAPTCHA TOKEN validation PASSED`);
            } else {
                grecaptcha.reset(recaptcha.recaptchaWidget);
                contactForm.$error.removeClass('d-none');
                logger.log(`RECAPTCHA TOKEN validation FAILED`);
            }
            contactForm.submitForm();
        });
    },

    // FORM REASONS
    selectOptionTemplate(name, title, reasons) {
        return `<div class="form-group">
                <label class="form-label" for="contact-form__reason">${title} *</label>
                <select id="${name}" 
                class="dropdown bootstrap-select form-control form-control--select bs-select--invisible"
                name="${name === contactForm.ZENDESK_CODE ? name : ''}"
                title="${name !== contactForm.ZENDESK_CODE ? this.translations.mainReason : this.translations.subReason}" required>
                ${reasons.map(option => `<option value="${option.zendeskCode || option.code}">${option.label}</option>`)}
                </select>
                </div>`;
    },

    thirdOptionTemplate(data) {
        return `<div class="form-group zen_answer">
                    <label class="form-label" for="contact-form__reasonAnswer">
                    ${data.additionalInfo.label}${data.additionalInfo.mandatory ? ' *' : ''}
                    </label>
                    <input id="contact-form__reasonAnswer"
                    name="additionalInfo"
                    class="form-control"
                    placeholder="${data.additionalInfo.placeholder}"
                    type="text" 
                    ${data.additionalInfo.mandatory ? `required="required"` : ''}
                    autocomplete="false">
               </div>`;
    },

    /**
     * Re-cache contact form reason dynamic choice fields
     */
    refreshFieldCache() {
        this.$firstOption = this.$form.find('#mainReason');
        this.$subOption   = this.$form.find('#zendeskCode');
    },

    cleanupFields() {
        this.$form.find('.zen_answer').remove();
        this.$form.find('.zen_info').remove();
    },

    infoMessage(data) {
        return `<div class="form-group zen_info"><span>${data.message || ''}</span><div>`;
    },

    firstOptionChange() {
        this.$subOption.length ? this.$subOption.selectpicker('destroy').parent().remove() : '';
        this.cleanupFields();
        this.$form.children().eq(2).after(
                contactForm.selectOptionTemplate(contactForm.ZENDESK_CODE, contactForm.zendesk.translations.subReason,
                        contactForm.activeReason[0].reasons));

        contactForm.refreshFieldCache();

        this.$subOption.selectpicker({
            style:      'btn-select',
            dropupAuto: true
        }).on('changed.bs.select', function (e) {
            contactForm.cleanupFields();
            const secondReasonValue     = $(e.currentTarget).selectpicker('val');
            contactForm.activeSubReason = contactForm.activeReason[0].reasons.filter((item) => item.zendeskCode === secondReasonValue);
            contactForm.refreshFieldCache();
            contactForm.secondOptionChange();
        });
    },

    secondOptionChange() {
        // either input or error message
        const data = contactForm.activeSubReason[0];

        if ("additionalInfo" in data) {
            this.$form.children().eq(3).after(this.thirdOptionTemplate(data));
        }

        if ("message" in data) {
            this.$form.children().eq(3).after(this.infoMessage(data));
        }
    },

    renderReasons() {
        $('.contact-page').removeClass('contact-page--hidden');

        this.$form.children().eq(1).after(
                this.selectOptionTemplate(contactForm.MAIN_REASON, contactForm.zendesk.translations.mainReason, contactForm.zendesk.reasons));

        this.refreshFieldCache();

        this.$firstOption.selectpicker({
            style: 'btn-select', dropupAuto: true
        });

        this.$firstOption.on('changed.bs.select', function (e) {
            const firstReasonValue   = $(e.currentTarget).selectpicker('val');
            contactForm.activeReason = contactForm.zendesk.reasons.filter((item) => item.code === firstReasonValue);
            contactForm.refreshFieldCache();
            contactForm.firstOptionChange();
        });
    },

    // FORM UPLOAD
    singleFileSelectedTemplate(file, index) {
        const {size, unit, realSize} = fileHelpers.readFileSize(file.size);
        const isBigFile              = realSize > contactForm.FILE_SIZE_MAX;
        const isAllowedFile          = contactForm.checkFileType(file);

        if (isBigFile || !isAllowedFile) {
            contactForm.$errorFileSize.removeClass('d-none');
            contactForm.filesValid = false;
        }

        return `<div class="contact-form__file ${isBigFile || !isAllowedFile ? 'contact-form__file-big' : ''}" data-file-index="${index}">
                    <div class="contact-form__file-description-wrapper">
                       <svg class="icon contact-form__file-icon">
                            <use xlink:href="#icon-invoice"></use>
                       </svg>
                        <div class="contact-form__file-description">
                            <div class="contact-form__uploading-in-progress">
                            <div class="contact-form__uploading-in-progress-text">${contactForm.UPLOAD_TEXT}</div>
                             <small>(${file.name}, ${size}${unit})</small>
                            </div>
                            <div class="contact-form__file-name">
                                <span>${file.name}</span>
                                <span>,&nbsp;${size}${unit}</span>
                            </div>
                        </div>
                    </div>
                    <svg class="icon contact-form__remove-icon">
                        <use xlink:href="#icon-close-v2"><use>
                    </svg>
                </div>`;
    },

    checkFileType(file) {
        const fileType = file.name.split('.');
        return contactForm.ALLOWED_FILES.includes(fileType[fileType.length - 1]);
    },

    renderAddedFiles() {
        contactForm.filesValid = true;
        contactForm.$errorFileSize.addClass('d-none');
        this.$selectedFilesContainer.empty();
        contactForm.files.forEach((file, index) => {
            this.$selectedFilesContainer.append(contactForm.singleFileSelectedTemplate(file, index));
        });
    },

    handleFileSelect() {
        const newUploadInput      = document.createElement('input');
        const allowedTypes2Select = contactForm.ALLOWED_FILES.map(ext => `.${ext}`).join(', ');

        newUploadInput.type = 'file';
        newUploadInput.setAttribute('multiple', 'multiple');
        newUploadInput.setAttribute('accept', allowedTypes2Select);

        const temp = $(newUploadInput);
        temp.click();

        temp.on('change', function (e) {
            const files = e.target.files;
            for (let index = 0; index < files.length; index++) {
                contactForm.files.push(files.item(index));
            }
            contactForm.files.splice(contactForm.MAX_FILES);
            contactForm.renderAddedFiles();
            contactForm.checkButtonVisuals();
            contactForm.recalculateFormState();
        });
    },

    removeFile() {
        contactForm.files.splice($(this).parent().data('file-index'), 1);
        contactForm.renderAddedFiles();
        contactForm.checkButtonVisuals();
    },

    checkButtonVisuals() {
        const filesInUse      = contactForm.files.length;
        const controlsWrapper = contactForm.$form.find('.contact-form__uploader-control');

        if (filesInUse < 1) {
            controlsWrapper.find('.js-contact-form__button--initial').removeClass('d-none');
            controlsWrapper.find('.js-contact-form__button--more').addClass('d-none');
            controlsWrapper.removeClass('d-none');
        } else if (filesInUse > contactForm.MAX_FILES - 1 || contactForm.isUploadDone) {
            controlsWrapper.addClass('d-none');
        } else {
            controlsWrapper.removeClass('d-none');
            controlsWrapper.find('.js-contact-form__button--initial').addClass('d-none');
            controlsWrapper.find('.js-contact-form__button--more').removeClass('d-none');
        }
    },

    uploadFiles() {
        const tempForm = new FormData();

        this.files.forEach(file => {
            tempForm.append(`file`, file);
        });

        tempForm.append('fileContextCode', contactForm.formUID);

        contactForm.$errorUpload.addClass('d-none');
        contactForm.$form.find('button[type=submit]').attr('disabled', 'disabled');
        contactForm.$form.find('.contact-form__uploader-control').addClass('d-none');
        contactForm.$form.find('.contact-form__file').addClass('uploading');

        return $.ajax({
                    url:   "/contact/upload/", type: "POST",
                    data:  tempForm,
                    cache: false, datatype: false, contentType: false, processData: false,

                    xhr: function () {
                        var myXhr = $.ajaxSettings.xhr();
                        if (myXhr.upload) {
                            // For handling the progress of the upload
                            myXhr.upload.addEventListener("progress", function (e) {
                                if (e.lengthComputable) {
                                    contactForm.$progress
                                               .removeClass('d-none')
                                               .attr({
                                                   value: e.loaded, max: e.total
                                               });
                                }
                            }, false);
                        }
                        return myXhr;
                    }
                })
                .done(function (response) {
                    logger.log("Upload: SUCCESS", response);
                    contactForm.isUploadDone = true;
                    contactForm.$form.find('button[type=submit]').removeAttr('disabled');
                    contactForm.$form.find('.contact-form__file').removeClass('uploading').addClass('uploaded');
                    contactForm.$errorUpload.addClass('d-none');
                    contactForm.attachUniqueId();
                    contactForm.submitForm();
                })
                .fail(function (response) {
                    logger.log("Upload: FAIL", response);
                    contactForm.isUploadDone = false;
                    contactForm.$form.find('button[type=submit]').removeAttr('disabled');
                    contactForm.$form.find('.contact-form__file').removeClass('uploading');
                    contactForm.$errorUpload.removeClass('d-none');
                })
                .always(function () {
                    contactForm.checkButtonVisuals();
                    contactForm.$progress.addClass('d-none');
                });
    },

    // FORM DATA SUBMIT
    submitFormData() {
        $.ajax({
             method: 'POST',
             url:    this.$form.attr('url'),
             data:   this.$form.serialize()
         })
         .done(function (response) {
             if (!$('.page-csPage').length) {
                 const pageReplaceClass = ".content-page-form";
                 const formToReplace    = $(response).find(pageReplaceClass);
                 contactForm.$contactPage.find(pageReplaceClass).html(formToReplace);
             } else {
                 contactForm.$formWrapper.hide();
                 contactForm.$formSuccess.removeClass('d-none');
             }
         })
         .fail(function () {
             contactForm.$form.find('button[type=submit]').removeAttr('disabled');
             contactForm.$errorForm.removeClass('d-none');
         });
    }
}

$(() => {
    $('.page-contactPage').length ? contactForm.init() : false;
});

